import styles from "./style.module.scss";

const SearchComponent = ({makeSearch}) => {
  return (
    <div className={styles.mainComponent}>
      <button
        className={`${styles.button}`}
        onClick={makeSearch}
      >
        Search
      </button>
    </div>
  )
}

export default SearchComponent;
